/**
 * Asynchronously loads the component for AdminCourseCandidates
 */

import { lazyLoad } from "utils/loadable";

export const AdminCourseCandidates = lazyLoad(
  () => import("./index"),
  (module) => module.AdminCourseCandidates
);